import React, { useState } from 'react';
import { Box, BottomNavigationAction, Link, Fab, Tabs, Tab, AppBar } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useHistory, useLocation } from 'react-router-dom'
import { Formik, Form } from 'formik';
import moment from 'moment';
import { extraInfoValidation } from '../utils/extrainfo';

import { useStore } from '../Store'
import useOnlineStatus from '../hooks/useOnlineStatus';
import { useConfirm } from './ConfirmDialog'
import { useToaster } from './Toaster'
import useVisits from '../hooks/useVisits'

// vaste onderdelen van het form
import VisitDetails from './VisitDetails';
import ObservationList from './ObservationList'
import ObservationDetails from './ObservationDetails'
import Header from './Header'

import TabPanel from './TabPanel';
import ActionBar from './ActionBar';
import SaveIcon from '@material-ui/icons/Save';
import CheckIcon from '@material-ui/icons/Check';

import { geometry2geoJson } from '../utils/location';
import * as turf from '@turf/turf'

import { isEqual, diff } from '../utils/diff';
import { findPlot } from '../utils/';

const VisitContainer = () => {
  const [updating, setUpdating] = useState(false)
  const location = useLocation()
  const history = useHistory()

  if (!location.state) history.push('/')

  const [visit, setVisit] = useState(location.state?.visit)
  //const [values, setValues] = useState()

  const [page, setPage] = React.useState("visit")

  const { confirm } = useConfirm()
  const { showError, showMessage } = useToaster()
  const isOnline = useOnlineStatus()
  const { settings, plots, years, year, setYear, removeState, createObservation } = useStore()
  const { updateVisit, activateVisit } = useVisits()

  const [tabValue, setTabValue] = useState(0)

  const formRef = React.useRef()
  //const saveStateRef = React.useRef(saveState)
  // check for navigation without setting props...

  const canActivate = (visit && visit.statusId === 4 && visit.statusRights >= 2)
  const canEdit = (visit && visit.statusId === 3 && visit.visitRights >= 2)

  const bezoekGereed = (process.env.REACT_APP_PROJECTID.match(/(58|46)/) ? "Bezoek gereed" : "Opslaan definitief")
  const bezoekHeropenen = (process.env.REACT_APP_PROJECTID.match(/(58|46)/) ? "Bezoek heropenen" : "Wijzigen naar concept")
  const bezoekOpslaan = (process.env.REACT_APP_PROJECTID.match(/(58|46)/) ? "Bezoek opslaan" : "Opslaan concept")

  /*
  // visit en values worden bij elke wijziging in localstorage opgeslagen
  useEffect(() => {
    let timer = setInterval(() => {
      const formik = formRef.current
      if (formik) {
        setValues(formik.values)
      }
    }, 5000)
    return () => { clearInterval(timer) }
  }, [])

  useEffect(() => {
    saveStateRef.current({ values })
  }, [values, saveStateRef])

  useEffect(() => {
    saveStateRef.current({ visit })
  }, [visit, saveStateRef])
  */

  // vul initiele waarden uit visit object
  let initialValues = {}
  if (visit) {
    if (location.state && location.state.values) {
      initialValues = { ...location.state.values }
    } else {
      initialValues = {
        id: visit.id,
        description: visit.description,
        duration: visit.duration,
        plot: (visit.plot ? visit.plot.id : ''),
        dateStart: visit.timeStart.substr(0, 10),
        timeStart: visit.timeStart.substr(11, 5),
        dateStop: visit.timeStop.substr(0, 10),
        timeStop: visit.timeStop.substr(11, 5),
        statusId: visit.statusId,
        observations: visit.sections.length > 0 ? visit.sections[0].observations : visit.observations.filter(obs => obs.delstaId === 0).map(obs => ({ ...obs })),
        sections: visit.sections || [],
        section: visit.sections.length > 0 ? 0 : - 1,
        observers: visit.roles.filter(role => role.statusId === 1 && [5,121].includes(role.roleTypeId)).map(role => role.person.id),
        buddies: visit.roles.filter(role => role.statusId === 1 && [122].includes(role.roleTypeId)).map(role => role.person),
        extraInfo: {},
        prtId: visit.prtId,
        roles: visit.roles,
        uploads: visit.uploads || [],
        observation: null,
        upload: null
      }
      settings.visitFields.forEach(field => {
        initialValues.extraInfo[field.name] = (field.name in visit.extraInfo ? visit.extraInfo[field.name] : "")
      })
    }
  }

  const validate = (values) => {
    const errors = {};

    const plot = findPlot(plots, values.plot)
    if (!values.dateStart) {
      errors.dateStart = 'verplicht';
    } else if (!moment(values.dateStart).isValid()) {
      errors.dateStart = 'ongeldige datum';
    } else if (moment(values.dateStart) > moment()) {
      errors.dateStart = 'toekomstige datum niet toegestaan'
    } else {
      const date = moment(values.dateStart)
      if (!years.some(item => date.isSameOrAfter(moment(item.timeStart)) && date.isBefore(moment(item.timeStop)))) {
        errors.dateStart = 'bezoekdatum valt buiten het seizoen'
      } else {
        // controle of bezoekdatum geldig is voor betreffende plot
        if (!plot
          || (plot.timeStart !== null && !date.isSameOrAfter(moment(plot.timeStart)))
          || (plot.timeStop !== null && !date.isBefore(moment(plot.timeStop)))) {
          errors.dateStart = `${values.plot} bezoekdatum ongeldig voor dit telgebied`
        }
      }
    }

    if (!values.timeStart) {
      errors.timeStart = 'verplicht';
    } else if (!values.timeStart.match('^([01][0-9]|2[0-3]):[0-5][0-9]$')) {
      errors.timeStart = 'ongeldige tijd'
    }

    if (process.env.REACT_APP_PROJECTID === "57") {
      // zomer of zolder?
      const cluster = findPlot(plots, plot.parentId)
      const zomer = cluster && 'doel' in cluster.parent.extraInfo && cluster.parent.extraInfo['doel'] === 'zomer'
      let value = values.duration
      if (value && (isNaN(parseInt(value)) || value < 0 || value > 999)) {
        errors.duration = "ongeldige waarde"
      }
      if (zomer && !values.extraInfo.volledigheid.match(/(3|4)/)) {
        let required = ['tellingtype', 'telmethode', 'trend', 'ndff']
        required.forEach((name) => {
          if (!values.extraInfo[name]) errors[`extraInfo.${name}`] = 'verplicht'
        })
        const telmethode = values.extraInfo.telmethode
        required = []
        if (telmethode === 'zwermen') required.push('zwermen_begintijd', 'zwermen_eindtijd')
        if (telmethode === 'uitvlieg') required.push('uitvlieg_begintijd', 'uitvlieg_eindtijd')
        if (telmethode === 'vliegroute') required.push('vliegroute_begintijd', 'vliegroute_eindtijd')
        required.forEach((name) => {
          if (!values.extraInfo[name]) errors[`extraInfo.${name}`] = 'verplicht'
        })
        if (values.extraInfo[required[0]] && values.extraInfo[required[1]]) {
          // check if starttime not after endtime
          if (values.extraInfo[required[0]] > values.extraInfo[required[1]]) {
            showMessage("eindtijd voor begintijd?")
          }
        }
      }
    }

    if (process.env.REACT_APP_PROJECTID === "58") {
      if (values.timeStop) {
        if (!values.timeStop.match('^([01][0-9]|2[0-3]):[0-5][0-9]$')) {
          errors.timeStop = 'ongeldige tijd'
        } else if (!errors.timeStart && values.timeStop <= values.timeStart) {
          errors.timeStop = 'eindtijd niet voor starttijd'
        }
      }
    }

    if (values.observers.length === 0) {
      errors.observers = "geen waarnemer(s) ingevuld"
    }

    settings.visitFields.forEach(field => {
      const error = extraInfoValidation(field, settings.lists[field.name], values.extraInfo)
      if (error) errors[`extraInfo.${field.name}`] = error
    });
    if (process.env.REACT_APP_PROJECTID === "62" && values.extraInfo["volledigheid"] === "0") {
      errors['extraInfo.volledigheid'] = 'ongeldige waarde'
    }

    // observation validatons
    if (values.observation) {

      if (process.env.REACT_APP_PROJECTID === "57") {
        let name = ''
        name = `observation.taxLisTaxId`
        if (!values.observation.taxLisTaxId) {
          errors[name] = "kies een soort"
        } else {
          let value = values.observation.abundance
          name = `observation.abundance`
          const taxaList = settings.taxaLists.find(t => t.id === (values.prtId || plot.taxaListId))
          const taxItem = taxaList.taxa.find(item => item.id === values.observation.taxLisTaxId)
          if (taxItem.info.scale === 'exact_count') {
            if (!value || isNaN(parseInt(value)) || value <= 0 || value > 10000) {
              errors[name] = "ongeldige waarde"
            }
          }
        }
      }

      if (process.env.REACT_APP_PROJECTID.match("(58|46|62)")) {
        let name = ''
        let value = values.observation.abundance
        name = `observation.abundance`
        if (!value || isNaN(value) || value < 0 || value > 10000) {
          errors[name] = "ongeldige waarde"
        }

        name = `observation.taxLisTaxId`
        if (!values.observation.taxLisTaxId) {
          errors[name] = "kies een soort"
        }
      }

      if (process.env.REACT_APP_PROJECTID.match("(56|58)")) {
        if (values.observation.location) {
          const location = values.observation.location

          if (location.buffer > 100) {
            errors['observation.location.buffer'] = 'locatie niet nauwkeurig genoeg.'
          }

          // controle of detail locatie in het gebied valt
          var pt = turf.buffer(turf.point(geometry2geoJson(location.geometry).coordinates), 100, { units: 'meters' })
          var geo = geometry2geoJson(plot.location.geometry)
          var poly
          if (geo.type === 'Polygon') {
            poly = turf.polygon(geo.coordinates)
          } else {
            var line = turf.lineString(geo.coordinates)
            poly = turf.lineToPolygon(line)
          }
          if (!turf.booleanIntersects(pt, poly)) {
            errors['observation.location.pos'] = 'locatie valt niet binnen het gebied'
          }
        } else {
          if (process.env.REACT_APP_PROJECTID === "56") {
            errors['observation.location.pos'] = 'geef een locatie aan op de kaart'
          }
        }
      }
      const extraInfo = values.observation.extraInfo
      settings.observationFields.forEach(field => {
        const error = extraInfoValidation(field, settings.lists[field.name], extraInfo)
        if (error) errors[`observation.extraInfo.${field.name}`] = error
      });

    }

    return errors;
  }

  const mapValuesToVisit = (values) => {
    const newVisit = { ...visit }
    delete newVisit.error
    newVisit.id = values.id
    newVisit.description = values.description
    newVisit.duration = values.duration
    newVisit.prtId = values.prtId

    const plot = findPlot(plots, values.plot)

    if (plot) {
      newVisit.plot = { id: plot.id, description: plot.description }
    }
    switch (process.env.REACT_APP_PROJECTID) {
      case "56":
      case "57":
      case "62":
        newVisit.timeStart = `${values.dateStart}T00:00:00`
        newVisit.timeStop = moment(newVisit.timeStart).add(1, 'days').format('YYYY-MM-DDTHH:mm:00')
        break;
      default:
        newVisit.timeStart = `${values.dateStart}T${values.timeStart}:00`
        newVisit.timeStop = `${values.dateStart}T${values.timeStop}:00`
    }
    newVisit.observations = [...values.observations]
    newVisit.sections = [...values.sections]
    settings.visitFields.forEach(field => {
      if (field.name in newVisit.extraInfo || values.extraInfo[field.name]) {
        newVisit.extraInfo[field.name] = values.extraInfo[field.name]
      }
    })
    const roles = visit.roles.map(r => { return { ...r } })
    // vul statusId bestaande roles op basis van observers array
    roles.forEach(r => r.statusId = (values.observers.some(id => id === r.person.id || values.buddies.some(buddy => buddy.id === r.person.id)) ? 1 : 2))
    // voeg nieuwe observers toe aan roles array
    values.observers
      .filter(id => !roles.some(r => r.person.id === id))
      .forEach(id => roles.push(
        { 
          id: -1, 
          statusId: 1,
          roleTypeId: parseInt(process.env.REACT_APP_PROJECTID) === 61 ? 121 : 5,
          person: { id: id } 
        }))
    // voeg nieuwe buddies toe aan roles array
    values.buddies
      .filter(buddy => !roles.some(r => r.person.id === buddy.id))
      .forEach(buddy => roles.push(
        { 
          id: -1, 
          statusId: 1,
          roleTypeId: 122,
          person: { id: buddy.id } 
        }))
    newVisit.roles = roles
    newVisit.abundanceTotal = 0;
    //newVisit.observations.filter(obs => obs.delstaId === 0).map(obs => newVisit.abundanceTotal += ~~obs.abundance)
    newVisit.uploads = values.uploads
    return newVisit
  }

  const isValid = async (formik) => {
    const errors = await formik.validateForm(formik.values)
    if (Object.keys(errors).filter(f => !f.startsWith('observation.')).length > 0) {
      showError('Een of meerdere velden hebben ongeldige waarde'
        //+ '\n' + JSON.stringify(errors)
        //+ '\n' + JSON.stringify(formik.values)
      )
      return false
    }
    return true
  }

  const isValidObservation = async (formik) => {
    const errors = await formik.validateForm(formik.values)
    if (Object.keys(errors).filter(f => f.startsWith('observation.')).length > 0) {
      showError('Een of meerdere velden hebben ongeldige waarde'
        //+ '\n' + JSON.stringify(errors)
        //+ '\n' + JSON.stringify(formik.values)
      )
      return false
    }
    return true;
  }

  //
  // main form event handlers
  //
  const saveVisit = async (finish = false) => {
    const formik = formRef.current
    if (!formik.values.timeStop) {
      formik.values.timeStop = moment().add(1, 'minutes').format('HH:mm')
    }
    if ('objectInfo' in formik.values) {
      Object.keys(formik.values.objectInfo)
        .filter(f => formik.values.objectInfo[f] !== formik.initialValues.objectInfo[f])
        .forEach(f => formik.values.extraInfo[f] = formik.values.objectInfo[f])
    }
    const valid = await isValid(formik)
    if (!valid) return
    const newvisit = mapValuesToVisit(formik.values)
    try {
      await updateVisit(newvisit, finish, isOnline)
      if (process.env.REACT_APP_PROJECTID === "61") {
        showMessage("Bezoek opgeslagen")
      }
      setYear(years.find(item => moment(newvisit.timeStart).isSameOrAfter(moment(item.timeStart)))?.id || year)
      history.push("/")
    }
    catch (error) {
      showError(error)
    }
  }

  const handleFinishVisit = async () => {
    await handleSaveVisit(true)
  }

  const handleSaveVisit = async (finish = false) => {
    setUpdating(true)
    await saveVisit(finish)
    setUpdating(false)
  }

  const handleActivateVisit = async () => {
    try {
      setUpdating(true)
      const active = await activateVisit(visit)
      setVisit(active)
    }
    catch (error) {
      showError(error)
    }
    finally {
      setUpdating(false)
    }
  }

  const cancel = async () => {
    const formik = formRef.current
    let values
    let initialValues
    if (parseInt(process.env.REACT_APP_PROJECTID) === 46) {
      let { section: x1, observations: x2, ...x3 } = formik.values
      let { section: y1, observations: y2, ...y3 } = formik.initialValues
      values = x3
      initialValues = y3
    } else {
      values = formik.values
      initialValues = formik.initialValues
    }

    if (!isEqual(initialValues, values)) {
      console.log(diff(initialValues, values))
      const confirmed = await confirm(`Wilt u de wijzigingen annuleren?`)
      if (!confirmed) return
    }
    removeState()
    history.push('/')
  }

  //
  // observation event handlers
  //
  const handleSelectObservation = (obs) => {
    const formik = formRef.current
    const observation = JSON.parse(JSON.stringify(obs))
    settings.observationFields.forEach(field => {
      observation.extraInfo[field.name] = (field.name in observation.extraInfo ? observation.extraInfo[field.name] : "")
    })
    formik.setFieldValue('observation', observation)
    setPage('observation')
  }

  const handleAddObservation = () => {
    const formik = formRef.current
    const observation = createObservation()
    settings.observationFields.forEach(field => {
      observation.extraInfo[field.name] = (field.name in observation.extraInfo ? observation.extraInfo[field.name] : "")
    })
    formik.setFieldValue('observation', observation)
    setPage('observation')
  }

  const handleCancelObservation = async (index) => {
    const formik = formRef.current

    const initialValues = formik.values.observations.find(obs => obs.id === formik.values.observation.id) || {}

    if (!isEqual(initialValues, formik.values.observation)) {
      const confirmed = await confirm(`Wilt u de wijzigingen annuleren?`)
      if (!confirmed) return
    }

    // reset geselecteerde waarneming
    const errors = formik.errors
    // verwijder eventueel observation errors
    Object.keys(errors).filter(key => key.startsWith("observation.")).forEach(key => delete errors[key])
    formik.setFieldValue('observation', null)
    setPage('visit')
  }

  const handleDeleteObservation = async (obs) => {
    const canDelete = await confirm(`Wilt u deze waarneming verwijderen?`)
    if (canDelete) {
      const formik = formRef.current
      obs.delstaId = 1
      obs.dirty = 1
      const observations = formik.values.observations.filter(obs => obs.id > 0 || obs.delstaId === 0)
      formik.setFieldValue('observations', observations)
    }
  }

  const handleSubmitObservation = async () => {
    const formik = formRef.current
    const valid = await isValidObservation(formik)
    if (!valid) return

    const obs = { ...formik.values.observation }

    const oldvalues = formik.values.observations.find(old => old.id === obs.id) || {}
    if (JSON.stringify(oldvalues) !== JSON.stringify(obs)) {
      obs.dirty = 1
    }

    const observations = formik.values.observations.map(o => o.id === obs.id ? obs : o)
    if (!observations.some(o => o.id === obs.id)) {
      observations.push(obs)
    }
    formik.setFieldValue('observations', observations)
    if (formik.values.section > -1) {
      formik.values.sections[formik.values.section].observations = observations
    }
    formik.setFieldValue('observation', null)
    setPage('visit')
  }

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    };
  }

  const visitForm = (formik) => {
    return (
      <>
        <Header title={`Bezoek ${formik.values.description}`} backAction={cancel} tabValue={tabValue} handleChange={handleChange} />
        <AppBar position="sticky" style={{ top: '56px' }} >
          <Tabs value={tabValue} onChange={handleChange} aria-label="tabs" variant="fullWidth">
            <Tab label="Bezoekgegevens" {...a11yProps(0)} />
            <Tab label="Waarnemingen" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <Box m={2} style={{ marginBottom: '56px' }}>
          <TabPanel value={tabValue} index={0}>
            <VisitDetails formik={formik} readonly={!canEdit} />
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <ObservationList
              readonly={!canEdit}
              formik={formik}
              observations={formik.values.observations}
              onSelect={handleSelectObservation}
              onDelete={handleDeleteObservation} />
            {canEdit 
              && !(parseInt(process.env.REACT_APP_PROJECTID) === 61) 
              && !(parseInt(process.env.REACT_APP_PROJECTID) === 46 && formik.values.sections[formik.values.section].statusId == "4")
              && <Fab color="secondary" aria-label="add" onClick={handleAddObservation}>
              <AddIcon />
            </Fab>}
          </TabPanel>
        </Box>

        {(canEdit || canActivate) &&
          <ActionBar>
            {canEdit && <BottomNavigationAction disabled={updating} label={bezoekGereed} component={Link} onClick={() => handleFinishVisit()} style={{ color: '#00547d' }} icon={<CheckIcon />} />}
            {canActivate && isOnline && <BottomNavigationAction disabled={updating} label={bezoekHeropenen} component={Link} onClick={() => handleActivateVisit()} style={{ color: '#00547d' }} icon={<CheckIcon />} />}
            {canEdit && <BottomNavigationAction disabled={updating} label={bezoekOpslaan} component={Link} onClick={() => handleSaveVisit(false)} style={{ color: '#00547d' }} icon={<SaveIcon />} />}
          </ActionBar>}
      </>
    )
  }

  const observationForm = (formik) => {
    return (
      <ObservationDetails
        readonly={!canEdit}
        formik={formik}
        handleCancel={() => handleCancelObservation()}
        handleSubmit={() => handleSubmitObservation()}
      />
    )
  }

  return (
    visit ?
      <Formik
        initialValues={initialValues}
        validate={canEdit ? validate : null}
        innerRef={formRef}
        validateOnBlur={false}
        validateOnChange={true}
      >
        {(formik) => (
          <Form>
            {page === "visit" ? visitForm(formik) : observationForm(formik)}
          </Form>
        )}
      </Formik> : null
  )
}


export default VisitContainer